import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { keys as calendarKeys } from "../../calendar/api/keys";
import { keys as topicsKeys } from "../../topics/api/keys";
import { keys as remindersKeys } from "./keys";
import { useSpace } from "../../../hooks/useSpace";

type Command = Database['public']['Tables']['reminders']['Update'];

async function updateReminder(reminderId: string, reminder: Command) {
  const { data, error } = await apiClient
    .from('reminders')
    .update(reminder)
    .eq('id', reminderId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

type Variables = {
  reminderId: string;
  command: Command;
}

export default function useUpdateReminder() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: ({ reminderId, command }: Variables) => updateReminder(reminderId, command),
    onSuccess: (_, { reminderId }) => {
      queryClient.invalidateQueries({ queryKey: remindersKeys.lists() });
      queryClient.invalidateQueries({ queryKey: remindersKeys.upcomingAll() });
      queryClient.invalidateQueries({ queryKey: remindersKeys.detail(reminderId) });
      queryClient.invalidateQueries({ queryKey: calendarKeys.list() });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: topicsKeys.pendingSubTopics(currentSpace.id) });
      }
    },
  });
}
